import type { RestorableRequestedMode } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const shouldRestoreMaxModeFromLastRequestedMode = (
	lastRequestedMode: RestorableRequestedMode | undefined,
): boolean => lastRequestedMode === 'MAX';
